import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../../utils/constants";

import "./styles.css";

function Logo({ alternative = false, big = false }) {
  const navigate = useNavigate();
  return (
    <div
      className={`header-logo ${alternative ? "alternative" : ""}`}
      onClick={() => navigate(ROUTE.home)}
    >
      <div className={`logo-content ${big ? "big" : ""}`}>
        <img src={`${process.env.PUBLIC_URL}/assets/basilisco-logo.png`} alt="Logo Basilisco" />
        <div>
          <span>Basilisco</span>
        </div>
      </div>
    </div>
  );
}

export default Logo;
